const edit_image_AI_page = {
  edit_image: 'Edit image',
  regenerated_image: 'Re-generate the image',
}

export default edit_image_AI_page
